import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SignUpWithEmailUI from './SignUpWithEmailUI.js'

class SignUpWithEmailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
      // name
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // email
      email: '',
      emailError: null,
      // password
      password: '',
      passwordError: null,
      // accountName
      accountName: '',
      accountNameError: null,
      // countryCode
      countryCode: this.props.context.session.countryCode,
      countryCodeError: null,
      countryList: null,
      // prices
      priceId: null,
      priceIdError: null,
      priceList: null,
      // captcha
      captchaValue: null,
      captchaValueError: null
    }
    // https://reactjs.org/docs/refs-and-the-dom.html
    this.captchaRef = React.createRef();
  }

  render() {
    return (
      <SignUpWithEmailUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // name
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => {this.setState({firstName: event.target.value})}}
        onLastNameChange={(event) => {this.setState({lastName: event.target.value})}}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => {this.setState({firstNameError: error})}}
        setLastNameError={(error) => {this.setState({lastNameError: error})}}
        // email
        email={this.state.email}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        emailError={this.state.emailError}
        setEmailError={(error) => {this.setState({emailError: error})}}
        // password
        password={this.state.password}
        onPasswordChange={(event) => {this.setState({password: event.target.value})}}
        passwordError={this.state.passwordError}
        setPasswordError={(error) => {this.setState({passwordError: error})}}
        // accountName
        accountName={this.state.accountName}
        onAccountNameChange={(event) => {this.setState({accountName: event.target.value})}}
        accountNameError={this.state.accountNameError}
        setAccountNameError={(error) => {this.setState({accountNameError: error})}}
        // countryCode
        countryCode={this.state.countryCode}
        onCountryCodeChange={this.onCountryCodeChange}
        countryCodeError={this.state.countryCodeError}
        setCountryCodeError={(error) => {this.setState({countryCodeError: error})}}
        countryList={this.state.countryList}
        // prices
        priceId={this.state.priceId}
        priceIdError={this.state.priceIdError}
        onPriceIdChange={(event) => {this.setState({priceId: event.currentTarget.getAttribute('data-price-id')})}}
        setPriceIdError={(error) => {this.setState({priceIdError: error})}}
        priceList={this.state.priceList}
        // captcha
        captchaKey={this.props.captchaKey}
        onCaptchaChange={(value) => {this.setState({captchaValue: value})}}
        captchaRef={this.captchaRef}
        captchaValueError={this.state.captchaValueError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCountries(context)
    this.getPrices(context, this.state.countryCode)
    this.getMessages(context)
  }

  onCountryCodeChange = (event) => {
    this.setState({countryCode: event.target.value})
    this.getPrices(this.props.context, event.target.value)
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    this.captchaRef.current.reset()
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/pub/signUpWithEmail`,
      this.onSignUpCallback, {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        password: this.state.password,
        accountName: this.state.accountName,
        countryCode: this.state.countryCode,
        priceId: this.state.priceId,
        reCaptchaValue: this.state.captchaValue
      }
    )
  }

  onSignUpCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'firstName':
            this.setState({firstNameError: error.message})
            break;
          case 'lastName':
            this.setState({lastNameError: error.message})
            break;
          case 'email':
            this.setState({emailError: error.message})
            break;
          case 'password':
            this.setState({passwordError: error.message})
            break;
          case 'accountName':
            this.setState({accountNameError: error.message})
            break;
          case 'countryCode':
            this.setState({countryCodeError: error.message})
            break;
          case 'priceId':
            this.setState({priceIdError: error.message})
            break;
          case 'reCaptchaValue':
            this.setState({captchaValueError: error.message})
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
      this.props.context.onLogin(response.session)
    }
  }

  getCountries(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/countries`,
      cacheKey: CacheKeys.Countries(),
      callback: this.getCountriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getCountriesCallback = (response) => {
    let countryList = response.countryList.map(country => ({key: country.code, value: country.name}))
    this.setState({countryList: countryList})
  }

  getPrices(context, countryCode) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/prices/countryCodes/${countryCode}`,
      cacheKey: CacheKeys.Prices('pub_signup', countryCode, context.locale),
      callback: this.getPricesCallback,
      ttlInSecs: 3600
    })
    // accountId is not sent when creating new account and subscription
    // accountId is sent when upgrading subscription in existing account
    cacheManager.getObject2(context, {}, {})
  }

  getPricesCallback = (response) => {
    this.setState({priceList: response.priceList, priceId: response.priceList[0].priceId})
  }

  getMessages(context) {
    let arr = [
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_email',
      'c_password',
      'c_account_name',
      'c_country',
      'c_plan',
      'c_sign_up',
      //
      'c_n_projects',
      'c_billed_daily',
      'c_billed_weekly',
      'c_billed_monthly',
      'c_billed_yearly',
      //
      'c_free_trial',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_signup_w_em', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SignUpWithEmailSF
